export const switchLanguageOnFields = (selectedLanguage, formTranslation) => {
  if(formTranslation){
    formTranslation.translationFormFields.forEach(translationFormField => {
      switch(translationFormField.type) {
        case 'text-field':
          translateInputText(selectedLanguage, translationFormField);
          break;
        case 'text-area':
          translateInputText(selectedLanguage, translationFormField);
          break;
        case 'number':
          translateInputText(selectedLanguage, translationFormField);
          break;
        case 'date-field':
          translateInputText(selectedLanguage, translationFormField);
          break;
        case 'image':
          translateImageText(selectedLanguage, translationFormField);
          break;
        case 'button':
          translateButton(selectedLanguage, translationFormField);
          break;
        case 'checkbox-group':
          translateOptionsGroup(selectedLanguage, translationFormField);
          break;
        case 'radio-group':
          translateOptionsGroup(selectedLanguage, translationFormField);
          break;
        case 'select':
          translateSelect(selectedLanguage, translationFormField);
          break;
        case 'header':
          translateHeader(selectedLanguage, translationFormField);
          break;
        case 'paragraph':
          translateHeader(selectedLanguage, translationFormField);
          break;
        case 'yesno-group':
          translateYesNoGroup(selectedLanguage, translationFormField);
          break;
        case 'redirect-in-x-seconds':
          translateRedirectInXSeconds(selectedLanguage, translationFormField);
          break;
        case 'url':
          translateURL(selectedLanguage, translationFormField);
          break;
        case 'metadata-key':
          translateMetadata(selectedLanguage, translationFormField);
          break;
        default:
      }
    });
    showHideHtmlElementsBasedOnLanguage(selectedLanguage);
  }
}

const showHideHtmlElementsBasedOnLanguage = (selectedLanguage) => {
   // Loop all elements with attribute name "data-lang" and hide/show the elements
   $("[data-lang]").each((i, e) => {
    if($(e).attr("data-lang").toLowerCase() !== selectedLanguage){
      $(e).css({display:"none"});
    }else{
      $(e).css({display:"block"});
    }
  })
}

const translateSelect = (selectedLanguage, translationSelectField) => {
  let selectedLangTransValues = translationSelectField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let selectElement = document.getElementsByClassName(translationSelectField.class)[0];
    if(selectElement){
      if(selectElement.labels && selectedLangTransValues.label){
        selectElement.labels[0].innerHTML = selectedLangTransValues.label;
      }
      // translating the options
      let selectElementOptions = selectElement.options;
      if(selectElementOptions.length >= 1){
        Array.from(selectElementOptions).forEach((selectOption, index) => {
          selectOption.innerHTML = selectedLangTransValues.options[index];
        });
      }
    }
  }
}
const translateHeader = (selectedLanguage, translationHeaderField) => {
  let selectedLangTransValues = translationHeaderField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let headerElement = document.getElementsByClassName(translationHeaderField.class)[0];
    if(headerElement){
      headerElement.innerHTML = selectedLangTransValues.label ? selectedLangTransValues.label : headerElement.innerHTML;
    }
  }
}
const translateButton = (selectedLanguage, translationButtonField) => {
  let selectedLangTransValues = translationButtonField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let buttonElement = document.getElementsByClassName(translationButtonField.class)[0];
    if(buttonElement){
      buttonElement.innerHTML = selectedLangTransValues.label ? selectedLangTransValues.label : buttonElement.innerHTML;
    }
  }
}
const translateInputText = (selectedLanguage, translationInputTextField) => {
  let selectedLangTransValues = translationInputTextField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let inputElement = document.getElementsByClassName(translationInputTextField.class)[0];
    if(inputElement){
      inputElement.placeholder = selectedLangTransValues.placeholder ? selectedLangTransValues.placeholder : inputElement.placeholder;
      if(inputElement.labels && selectedLangTransValues.label){
        inputElement.labels[0].innerHTML = selectedLangTransValues.label;
      }
    }
  }
}
const translateImageText = (selectedLanguage, translationImageTextField) => {
  let selectedLangTransValues = translationImageTextField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let imageElement = document.getElementsByClassName(translationImageTextField.class)[0];
    if(imageElement){
      if(imageElement.parentNode.children[0] && selectedLangTransValues.label){
        imageElement.parentNode.children[0].innerHTML = selectedLangTransValues.label;
      }
    }
  }
}
const translateURL = (selectedLanguage, translationURLField) => {
  let selectedLangTransValues = translationURLField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let urlElement = document.getElementsByClassName(translationURLField.class)[0];
    if(urlElement){
      urlElement.innerHTML = selectedLangTransValues.label;
    }
  }
}
const translateMetadata = (selectedLanguage, translationMetadataField) => {
  let selectedLangTransValues = translationMetadataField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let metadataKeyElement = document.getElementsByClassName(translationMetadataField.class)[0];
    if(metadataKeyElement){
      metadataKeyElement.innerHTML = selectedLangTransValues.label;
    }
  }
}
const translateYesNoGroup = (selectedLanguage, translationYesNoGroupField) => {
  let selectedLangTransValues = translationYesNoGroupField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let yesNoGroupElement = document.getElementsByClassName(translationYesNoGroupField.class)[0];
    if(yesNoGroupElement){
      // Translating yes no group label
      if(yesNoGroupElement.parentNode.children[0] && selectedLangTransValues.label){
        yesNoGroupElement.parentNode.children[0].innerHTML = selectedLangTransValues.label;
      }
      // Translating yes no buttons label
      if(yesNoGroupElement.children.length === 2){
        if(yesNoGroupElement.children[0].children[0]){
          yesNoGroupElement.children[0].children[0].innerHTML = selectedLangTransValues.yes;
        }
        if(yesNoGroupElement.children[1].children[0]){
          yesNoGroupElement.children[1].children[0].innerHTML = selectedLangTransValues.no;
        }
      }
    }
  }
}
const translateRedirectInXSeconds = (selectedLanguage, translationRedirectInXSecondsField) => {
  let selectedLangTransValues = translationRedirectInXSecondsField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let redirectInXSecElement = document.getElementsByClassName(translationRedirectInXSecondsField.class)[0];
    if(redirectInXSecElement){
      // Translating redirectInXSecElement label
      if(redirectInXSecElement.parentNode.children[0] && selectedLangTransValues.label){
        redirectInXSecElement.parentNode.children[0].innerHTML = selectedLangTransValues.label;
      }
      // Translating the group prefix and suffix messsage labels
      if(redirectInXSecElement.children.length === 3){
        // 3 means there is label structure like this prefixMsg + secs + suffixMsg
        // Translating the prefix and suffic message
        if(redirectInXSecElement.children[0]){
          redirectInXSecElement.children[0].innerHTML = selectedLangTransValues.prefix_msg + ' ';
        }
        if(redirectInXSecElement.children[2]){
          redirectInXSecElement.children[2].innerHTML = ' ' + selectedLangTransValues.suffix_msg;
        }
      }
    }
  }
}
const translateOptionsGroup = (selectedLanguage, translationOptionGroupField) => {
  let selectedLangTransValues = translationOptionGroupField.translations.find(t=>t.langName === selectedLanguage);
  if(selectedLangTransValues){
    let translateChkboxOptions = document.getElementsByClassName(translationOptionGroupField.class);
    if(translateChkboxOptions){
      // translating the chkGroupLabel first
      let firstChkboxOption = translateChkboxOptions[0];
      let chkBoxGroupLabel = null;
      if(firstChkboxOption && firstChkboxOption.parentNode.parentNode.parentNode.children[0]){
        chkBoxGroupLabel = firstChkboxOption.parentNode.parentNode.parentNode.children[0];
        chkBoxGroupLabel.innerHTML = selectedLangTransValues.label;
      }
      // translating the options
      Array.from(translateChkboxOptions).forEach((chkOption, index) => {
        chkOption.labels[0].innerHTML = selectedLangTransValues.options[index];
      });
    }
  }
}

